import QuestionSelectOptions from "pages/PreviewPage/QuestionSelectOptions/QuestionSelectOptions";

export default QuestionSelectOptions;
